<template>
    <div class="card-container">
        <common-top-form
            :model="formModel"
            :submitService="submitService"
            :submitData="submitData"
            @success="onSuccess"
            @openAddDialog="openAddDialog"
            :show="true"
            :selectShow="true"
            selectShowPower="/roulettelotteryfalse/select"
            addShowPower="/roulettelotteryfalse/add"
        >
            <el-form-item label="档期名称">
                <el-input
                    type="text"
                    maxlength="20"
                    v-model="formModel.scheduleName"
                    placeholder="请输入批次名称"
                ></el-input>
            </el-form-item>
            <el-form-item label="档期状态">
                <el-select v-model="formModel.pondStatus">
                    <el-option
                        v-for="item in enableStatus"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value"
                    >
                    </el-option>
                </el-select>
            </el-form-item>
        </common-top-form>
        <common-table :data="tableData" ref="commonTable" @handleChange="getPage">
            <el-table-column
                prop="scheduleName"
                label="档期名称"
                min-width="100"
                :formatter="formatterTableData"
                show-overflow-tooltip
            ></el-table-column>
            <el-table-column
                prop="integralNumber"
                label="抽奖所需积分"
                min-width="100"
                :formatter="formatterTableData"
                show-overflow-tooltip
            ></el-table-column>
            <el-table-column
                prop="lotteryNumber"
                label="循环次数"
                min-width="100"
                :formatter="formatterTableData"
                show-overflow-tooltip
            ></el-table-column>
            <el-table-column
                prop="startTime"
                label="开始时间"
                min-width="100"
                :formatter="formatterTableData"
                show-overflow-tooltip
            ></el-table-column>
            <el-table-column
                prop="endTime"
                label="结束时间"
                min-width="100"
                :formatter="formatterTableData"
                show-overflow-tooltip
            ></el-table-column>
            <el-table-column
                prop="pondStatus"
                label="状态"
                min-width="100"
                :formatter="typeStatus"
                show-overflow-tooltip
            ></el-table-column>
            <el-table-column label="操作" min-width="220">
                <template slot-scope="scope">
                    <el-button type="text" @click="configure(scope.row.id)"
                    >配置奖品
                    </el-button>
                    <el-button type="text" @click="openAddDialog(scope.row)"
                    >修改
                    </el-button>
                    <el-button type="text" @click="handleStatus(scope.row)"
                    >{{ scope.row.pondStatus == 0 ? "启用" : "禁用" }}
                    </el-button>
                    <el-button type="text" @click="handleDelete(scope.row)"
                    >删除
                    </el-button>
                </template>
            </el-table-column>
        </common-table>
        <form-dialog
            ref="formDialog"
            :formDialogTitle="itemId ? '修改' : '添加'"
            :model="dialogModel"
            :submitData="dialogData"
            labelWidth="120px"
            :rules="dialogRules"
            :dialogService="dialogService"
            @close="dialogClose"
            @success="dialogSuccess"
            class="note"
        >
            <el-form-item label="档期名称" prop="scheduleName">
                <el-input
                    type="text"
                    maxlength="10"
                    v-model="dialogModel.scheduleName"
                    placeholder="请输入"
                ></el-input>
            </el-form-item>
            <el-form-item label="抽奖所需积分" prop="integralNumber">
                <el-input-number
                    v-model="dialogModel.integralNumber"
                    :min="0"
                    :max="999999999"
                    :step="0"
                    :precision="0"
                    :controls="false"
                    placeholder="请输入"
                ></el-input-number>
            </el-form-item>
            <el-form-item label="循环次数" prop="lotteryNumber">
                <el-input-number
                    v-model="dialogModel.lotteryNumber"
                    :min="0"
                    :max="999999999"
                    :step="1"
                    :precision="0"
                    :controls="false"
                    placeholder="请输入"
                ></el-input-number>
            </el-form-item>
            <el-form-item label="开始时间" prop="startTime">
                <el-time-picker
                    v-model="dialogModel.startTime"
                    value-format="HH:MM:ss"
                    placeholder="选择开始时间">
                </el-time-picker>
            </el-form-item>
            <el-form-item label="结束时间" prop="endTime">
                <el-time-picker
                    v-model="dialogModel.endTime"
                    value-format="HH:MM:ss"
                    placeholder="选择结束时间">
                </el-time-picker>
            </el-form-item>
            <el-form-item label="说明" prop="pondRemark">
                <el-input
                    type="textarea"
                    :rows="3"
                    placeholder="请输入内容"
                    v-model="dialogModel.pondRemark"
                >
                </el-input>
            </el-form-item>
        </form-dialog>
    </div>
</template>

<script>
    import CommonTopForm from "components/common/CommonTopForm";
    import CommonTable from "components/common/CommonTable";
    import FormDialog from "../../dialog/FormDialog";
    import ShowInfoDialog from "../../dialog/ShowInfoDialog";

    import APPService from "service/APPService";

    import {encrypt, urlEncode, objKeySort} from "common/js/common-utils";
    import {loadMixin, dialogMixin, validatorsMixin} from "mixin";
    import {mapActions, mapGetters} from "vuex";

    export default {
        name: "roulettelotteryfalse",
        components: {
            CommonTopForm,
            CommonTable,
            FormDialog,
            ShowInfoDialog,
        },
        data() {
            return {
                itemId: "",
                formModel: {
                    scheduleName: "",
                    pondStatus: "",
                },
                tableData: [],
                submitService: APPService.roulettelListFalse,
                page: {},
                isPage: false,
                dialogModel: {
                    scheduleName: "",
                    lotteryNumber: 0,
                    integralNumber: undefined,
                    pondRemark: "",
                    startTime: "",
                    endTime: "",
                },
                dialogRules: {
                    scheduleName: [
                        {
                            required: true,
                            message: "请输入档期名称",
                        },
                    ],
                    integralNumber: [
                        {
                            required: true,
                            message: "请输入",
                        },
                    ],
                    pondRemark: [
                        {
                            required: true,
                            message: "请填写说明",
                        },
                    ],
                    lotteryNumber: [
                        {
                            required: true,
                            message: "请填写循环次数",
                        },
                    ],
                    startTime: [
                        {
                            required: true,
                            message: "请选择开始时间",
                        },
                    ],
                    endTime: [
                        {
                            required: true,
                            message: "请选择结束时间",
                        },
                    ],
                },
                enableStatus: [
                    {
                        value: "",
                        label: "全部",
                    },
                    {
                        value: "0",
                        label: "禁用",
                    },
                    {
                        value: "1",
                        label: "启用",
                    },
                ],
            };
        },
        inject: ["reload"],
        mixins: [loadMixin, dialogMixin, validatorsMixin],
        mounted() {
            this.load();
            this.page = this.$refs.commonTable.page;
        },
        computed: {
            submitData() {
                this.params = {
                    scheduleName: this.formModel.scheduleName,
                    pondStatus: this.formModel.pondStatus,
                    current: this.isPage ? this.page.currentPage : 1,
                    size: this.page.pageSize,
                };

                return this.params;
            },
            dialogData() {
                const char = this.dialogModel.pondRemark.trim().replace(/\n/g, "&xcq;");
                const params = {
                    scheduleName: this.dialogModel.scheduleName,
                    integralNumber: this.dialogModel.integralNumber,
                    lotteryNumber: this.dialogModel.lotteryNumber,
                    startTime: this.dialogModel.startTime,
                    endTime: this.dialogModel.endTime,
                    pondRemark: char,
                };
                if (this.itemId) {
                    console.log(this.itemId);
                    params.id = this.itemId;
                }
                return params;
            },
            dialogService() {
                return this.itemId ? APPService.roulettelEditFalse : APPService.roulettelAddFalse;
            },
            ...mapGetters(["serverType", "tatId", "userId"]),
        },
        watch: {},
        methods: {
            load() {
                this.formModel = {
                    pondStatus: "",
                };

                this.getList();
            },
            getPage() {
                this.isPage = true;
                this.getList();
            },
            getList() {
                this.doLoad(
                    this.submitService,
                    this.submitData,
                    (res) => {
                        this.doCheck(res, (res) => {
                            this.onSuccess(res);
                            this.isPage = false;
                        });
                    },
                    "信息获取失败"
                );
            },
            onSuccess(res) {
                this.doCheck(res, (res) => {
                    const result = res.contents;
                    this.tableData = result.rows;
                    this.page.currentPage = result.current;
                    this.page.total = result.total;
                    this.page.pageSize = result.size;
                });
            },
            openAddDialog(item) {
                this.itemId = item ? item.id : "";
                if (this.itemId) {
                    this.dialogModel = JSON.parse(JSON.stringify(item));
                    this.dialogModel.pondRemark = this.dialogModel.pondRemark.replace(
                        /&xcq;/g,
                        "\n"
                    );
                }
                this.$refs.formDialog.open();
            },

            dialogSuccess(res) {
                this.commonSuccess(res);
                this.$refs.formDialog.closeDialog();
            },
            handleDelete(item) {
                this.showConfirm("确定删除该数据？")
                    .then(() => {
                        this.doDelete(item.id);
                    })
                    .catch(() => {
                    });
            },
            doDelete(id) {
                this.doLoad(
                    APPService.roulettelDelFalse,
                    {
                        id: id,
                    },
                    (res) => {
                        this.doCheck(res, (res) => {
                            this.commonSuccess(res);
                        });
                    },
                    "操作失败"
                );
            },
            handleStatus(item) {
                this.showConfirm(`确定${item.pondStatus == 0 ? "启用" : "禁用"}该类别？`)
                    .then(() => {
                        this.doStatus(item);
                        this.getList();
                    })
                    .catch(() => {
                    });
            },
            doStatus(item) {
                if (item.pondStatus == 0) {
                    item.pondStatus = "1";
                } else {
                    item.pondStatus = "0";
                }

                this.doLoad(
                    APPService.roulettelStatusFalse,
                    {
                        id: item.id,
                        status: item.pondStatus,
                    },
                    (res) => {
                        this.doCheck(res, (res) => {
                            this.commonSuccess(res);
                        });
                    },
                    "操作失败"
                );
            },
            configure(id) {
                this.$router.push({
                    name: "configureprizesfalse",
                    params: {
                        item: id,
                    },
                });
            },
            dialogClose() {
                this.dialogModel = {
                    scheduleName: "",
                    integralNumber: undefined,
                    pondRemark: "",
                };
            },
            commonSuccess(res) {
                this.showSuccess(res.respMsg);
                this.getList();
            },
            typeStatus: function (row, column) {
                switch (row.pondStatus) {
                    case 0:
                        return "禁用";
                        break;
                    case 1:
                        return "启用";
                        break;
                    default:
                        return "--";
                }
            },
        },
    };
</script>
<style scoped>
    .mem-name p {
        margin-bottom: 20px;
        vertical-align: middle;
        line-height: 40px;
        color: rgba(170, 170, 170, 1);
    }

    .mem-name p:first-child {
        display: inline-block;
        width: 90px;
        text-align: right;
        vertical-align: middle;
        font-size: 14px;
        color: #606266;
        line-height: 40px;
    }
</style>



// WEBPACK FOOTER //
// src/view/page/AppManager/RouletteLotteryFalse.vue